import { UPDATE_USER, CLEAR_UPDATE_ERROR } from "./constants/actionTypes";

const initialState = {
  fetching: false,
  fetched: false,
  onError: false,
  error: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER.pending: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        onError: false,
        error: {}
      };
    }
    case UPDATE_USER.fulfilled: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: {}
      };
    }
    case UPDATE_USER.rejected: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        onError: true,
        error: action.payload
      };
    }
    case CLEAR_UPDATE_ERROR.default: {
      return { ...state, fetched: false, onError: false, error: {} };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export default reducer;
